import { render, staticRenderFns } from "./specialCoupon.vue?vue&type=template&id=2bb22a04&scoped=true"
import script from "./specialCoupon.vue?vue&type=script&lang=js"
export * from "./specialCoupon.vue?vue&type=script&lang=js"
import style0 from "./specialCoupon.vue?vue&type=style&index=0&id=2bb22a04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb22a04",
  null
  
)

export default component.exports